<!--
 * @Description: Description
 * @Author: ranli
 * @Date: 2026-04-14 15:50:49
 * @LastEditTime: 2026-04-24 15:54:21
 * @LastEditors: ranli
-->
<template>
  <div class="app-layout">
    <CHeader :title="headerTitle" :subtitle="headerSubtitle" :status-type="headerStatusType"
      :show-status-badge="headerShowStatusBadge" :status-text="headerStatusText" />
    <div class="app-layout-content">
      <router-view v-slot="{ Component, route }">
        <keep-alive v-if="route.meta.keepAlive">
          <component :is="Component" :key="route.name || route.path" />
        </keep-alive>
        <component :is="Component" v-else :key="route.fullPath" />
      </router-view>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import CHeader from '@/components/CHeader/index.vue'
import { useHeader } from '@/composables/useHeader.js'

const route = useRoute()
const {
  title: headerTitle,
  subtitle: headerSubtitle,
  statusType: headerStatusType,
  showStatusBadge: headerShowStatusBadge,
  statusText: headerStatusText,
} = useHeader()

const layout = computed(() => route.meta.layout || 'inner')
</script>

<style scoped lang="less">
.app-layout {
  padding-top: var(--mobile-header-height);
  height: 100vh;
  overflow-y: auto;
}
</style>
